import { HotelPaginationPropertiesType } from "@website/accommodation-ui/hotel-pagination/hotel-pagination.types";
import { useIsVisible } from "@website/hooks/is-visible";
import last from "lodash-es/last";
import orderBy from "lodash-es/orderBy";
import toNumber from "lodash-es/toNumber";
import uniq from "lodash-es/uniq";
import { useEffect } from "react";

export const useLoadMore = (properties: HotelPaginationPropertiesType) => {
  const { totalCount, pages, setPages } = properties;
  const { reference, inView } = useIsVisible();
  const maxPage = Math.ceil(totalCount / 20);

  useEffect(() => {
    const currentPage = toNumber(last(pages) || 1);
    const hasMorePage = maxPage > currentPage;
    if (inView && hasMorePage) {
      setPages((state) => orderBy(uniq([...state, currentPage + 1])));
    }
  }, [inView, maxPage, pages, setPages]);

  return { reference };
};
